var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from '../../decorators/injectable';
import { stateable } from '../../decorators/stateable';
/** The name of the module */
export const name = 'TriggerStrategy';
/** Default Options of the Options Interface */
const defaultOptions = {
    defaultVisibility: true,
    enableVisibilityToggling: false,
    additionalTriggers: null,
};
let TriggerStrategy = class TriggerStrategy {
    /**
     * Create a Trigger Strategy
     *
     * @param {Options} Object Data to initialize the component with
     */
    constructor(options) {
        this.element = options.element;
        this.classNames = options.classNames;
        // Optional params that can be set
        this.defaultVisibility = options.defaultVisibility ?? defaultOptions.defaultVisibility;
        this.enableVisibilityToggling = options.enableVisibilityToggling ?? defaultOptions.enableVisibilityToggling;
        if (options.additionalTriggers) {
            this.additionalTriggers = options.additionalTriggers instanceof HTMLElement ? [options.additionalTriggers] : options.additionalTriggers;
        }
        else {
            this.additionalTriggers = defaultOptions.additionalTriggers;
        }
        this.init();
    }
    /**
     * Initialize the trigger strategy
     */
    init() {
        // Initialize the state
        const initialState = {
            isVisible: this.defaultVisibility,
        };
        // Initialize the module's state
        this.initState(initialState);
        if (this.enableVisibilityToggling) {
            if (this.classNames.base) {
                this.element.classList.add(this.classNames.base);
            }
            // If the visible state is true, add the visible class name onto it (only applicable on init)
            if (this.getState().isVisible) {
                this.element.classList.add(this.classNames.visible);
            }
        }
        this.initAdditionalTriggerEventListeners();
    }
    /**
     * Perform any required cleanup to properly destroy the component
     */
    destroy() {
        if (this.additionalTriggers) {
            this.additionalTriggers.forEach((trigger) => {
                trigger.removeEventListener('click', this.element.click);
            });
        }
    }
    /**
     * Create click event listeners for each additional triggers
     */
    initAdditionalTriggerEventListeners() {
        if (!this.additionalTriggers) {
            return;
        }
        this.additionalTriggers.forEach((trigger) => trigger.addEventListener('click', () => this.element.click()));
    }
    /**
     * Toggles the visibility of the module
     */
    toggleVisibility() {
        if (!this.enableVisibilityToggling) {
            return;
        }
        this.setState({
            isVisible: !this.getState().isVisible,
        });
        this.element.classList.toggle(this.classNames.visible, this.getState().isVisible);
    }
    getTriggerElement() {
        return this.element;
    }
    /**
     * Gets the current state of the target
     */
    getVisibilityState() {
        return this.getState().isVisible;
    }
};
TriggerStrategy = __decorate([
    stateable(name),
    injectable(name)
], TriggerStrategy);
export default TriggerStrategy;
